import './localization/i18n.ts';
import {App} from './App.tsx';
import {CssBaseline, GlobalStyles} from '@mui/material';
import {PlanetThemeProvider} from './theme/PlanetThemeProvider.tsx';
import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PlanetThemeProvider>
      <GlobalStyles
        styles={{
          'html, body': {height: '100%', margin: 0},
          '#root': {height: '100%', width: '100%'},
          a: {cursor: 'pointer'},
        }}
      />
      <CssBaseline />
      <App />
    </PlanetThemeProvider>
  </StrictMode>,
);
